export default __webpack_public_path__ + "static/media/illustration-study-2-w.dd4aa5ce.webp";